import React from 'react';
import { Fade } from 'react-slideshow-image';

class Imageslider extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            images: []
        }
    }

    render() {
        const images = this.props.images;

        return(
        <Fade
            images={images}
            duration={5000}
            transitionDuration={1000}
        />
            )
    }
}

export default Imageslider;


// WEBPACK FOOTER //
// ./src/views/scorecard/Imageslider.js